module.exports = __webpack_public_path__ + "static/media/Microsoft_Internship_Project_Preview.a07a084a.gif";